import { enableMapSet } from "immer"
import { StateCreator, create } from "zustand"
import { devtools, subscribeWithSelector } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"

type StoreType<T extends object> = StateCreator<
    T,
    [
        ["zustand/devtools", never],
        ["zustand/subscribeWithSelector", never],
        ["zustand/immer", never]
    ],
    [],
    T
>

interface DevtoolsOptions {
    enabled?: boolean
    anonymousActionType?: string
    name?: string
    serialize?:
        | boolean
        | {
              date?: boolean
              regex?: boolean
              undefined?: boolean
              nan?: boolean
              infinity?: boolean
              error?: boolean
              symbol?: boolean
              map?: boolean
              set?: boolean
          }
}
enableMapSet()
const createStore = <T extends object>(
    store: StoreType<T>,
    devtoolsOptions?: DevtoolsOptions
) => create<T>()(devtools(subscribeWithSelector(immer(store)), devtoolsOptions as any))

export default createStore
